import classNames from 'classnames';
import React from 'react';
import Error from '../Error';
import styles from './Field.module.scss';

interface FieldProps {
  children: React.ReactNode;
  error?: string;
}

const Field = ({ children, error }: FieldProps): React.ReactElement => {
  return (
    <div className={classNames(styles.field, { [styles.field_state_error]: !!error })}>
      <div>{children}</div>
      {error ? <Error error={error} className={styles.fieldError} /> : null}
    </div>
  );
};

export default Field;
